// Every flag a pattern can carry, in the order a literal writes them, with what each one does to the search.
export interface FlagInfo {
  letter: string;
  label: string;
  description: string;
}

export const FLAGS: FlagInfo[] = [
  { letter: "g", label: "global", description: "Find every match rather than stopping at the first one." },
  { letter: "i", label: "ignore case", description: "Treat upper and lower case as the same letter." },
  { letter: "m", label: "multiline", description: "^ and $ match at every line break, not only at the ends." },
  { letter: "s", label: "dot all", description: ". matches a line break as well as everything else." },
  { letter: "u", label: "unicode", description: "Read the pattern by code point, with \\p{…} and \\u{…} available." },
  { letter: "v", label: "unicode sets", description: "Unicode, plus set notation in classes: [\\p{L}--[a-f]]." },
  { letter: "y", label: "sticky", description: "Match only where the last one ended, never searching forward." },
  { letter: "d", label: "indices", description: "Record where each group started and ended on the match." },
];

// Only the letters this page offers, each at most once and in the order above: a flag string is a set, not a list.
export function normaliseFlags(value: string | undefined): string {
  if (!value) return "";

  const chosen = new Set(value);
  // u and v are one switch at two settings, and a RegExp carrying both of them does not compile at all.
  if (chosen.has("v")) chosen.delete("u");

  return FLAGS.filter((flag) => chosen.has(flag.letter)).map((flag) => flag.letter).join("");
}

// The letters a chip group hands back, with the one just turned on winning the argument u and v have with each other.
export function chooseFlags(previous: string, next: string[]): string {
  const added = next.find((letter) => !previous.includes(letter));
  const exclusive = added === "u" ? "v" : added === "v" ? "u" : null;
  return normaliseFlags(next.filter((letter) => letter !== exclusive).join(""));
}
